import webWeights from "../helpers/webWeights";

const systemDenseWeights = {
  thin: webWeights.thin,
  light: webWeights.light,
  regular: webWeights.regular,
  semibold: webWeights.semibold,
  bold: webWeights.bold
};

export default systemDenseWeights;
